import { lazy, Suspense } from 'react';
import HeroNew from './components/HeroNew';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import ScrollToTopButton from '../../components/feature/ScrollToTopButton';
import {
  useSEO,
  generateWebPageSchema,
  generateOrganizationSchema,
  generateLocalBusinessSchema,
} from '../../utils/seo';

// Alle Sektionen unterhalb des Hero lazy laden
const BeforeAfterSlider = lazy(() => import('./components/BeforeAfterSlider'));
const Process = lazy(() => import('./components/Process'));
const Benefits = lazy(() => import('./components/Benefits'));
const Features = lazy(() => import('./components/Features'));
const Solutions = lazy(() => import('./components/Solutions'));
const Testimonials = lazy(() => import('./components/Testimonials'));
const CaseStudy = lazy(() => import('./components/CaseStudy'));
const FAQ = lazy(() => import('./components/FAQ'));
const CTA = lazy(() => import('./components/CTA'));

const SectionLoader = () => (
  <div className="py-16 flex items-center justify-center">
    <div className="w-8 h-8 border-4 border-brand-green border-t-transparent rounded-full animate-spin" />
  </div>
);

export default function HomePage() {
  try {
    useSEO({
      title: 'BR Webdesign & AI Solutions Titisee-Neustadt',
      description:
        'Webdesign Titisee-Neustadt: Moderne Webseiten, AI-Chatbots & SEO von Benjamin Reick. Fertig in unter 1 Woche. Jetzt kostenloses Erstgespräch sichern.',
      keywords:
        'Webdesign Titisee-Neustadt, Webdesign 79822, AI Chatbot Schwarzwald, SEO Titisee-Neustadt, Webentwicklung Baden-Württemberg',
      canonical: '/',
      schema: {
        '@context': 'https://schema.org',
        '@graph': [
          generateWebPageSchema(
            'BR Webdesign & AI Solutions Titisee-Neustadt',
            'Professionelles Webdesign in Titisee-Neustadt (79822). Benjamin Reick erstellt moderne Webseiten mit AI-Chatbots, SEO-Optimierung und DSGVO-Konformität. Webdesign Schwarzwald Baden-Württemberg.',
            '/'
          ),
          generateOrganizationSchema(),
          generateLocalBusinessSchema(),
        ],
      },
    });
  } catch (error) {
    console.error('SEO initialization failed:', error);
  }

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      {/* Hero sofort laden – kritisch für LCP */}
      <HeroNew />
      {/* Alle weiteren Sektionen lazy laden */}
      <Suspense fallback={<SectionLoader />}>
        <BeforeAfterSlider />
      </Suspense>
      <Suspense fallback={<SectionLoader />}>
        <Process />
      </Suspense>
      <Suspense fallback={<SectionLoader />}>
        <Benefits />
      </Suspense>
      <Suspense fallback={<SectionLoader />}>
        <Features />
      </Suspense>
      <Suspense fallback={<SectionLoader />}>
        <Solutions />
      </Suspense>
      <Suspense fallback={<SectionLoader />}>
        <Testimonials />
      </Suspense>
      <Suspense fallback={<SectionLoader />}>
        <CaseStudy />
      </Suspense>
      <Suspense fallback={<SectionLoader />}>
        <FAQ />
      </Suspense>
      <Suspense fallback={<SectionLoader />}>
        <CTA />
      </Suspense>
      <Footer />
      <ScrollToTopButton />
    </div>
  );
}
